import * as React from 'react';
import { observer } from 'mobx-react';
import { OptionDescription } from 'owa-options-controls';
import { Toggle, Spinner, SpinnerSize } from 'office-ui-fabric-react/lib';
import strings from 'owa-strings/owa-options-strings';
import getPublishedStatus from '../selectors/getPublishedStatus';
import isSaving from '../selectors/isSaving';
import setPublishedStatus from '../orchestration/setPublishedStatus';

const styles = require('./PublishPbpSection.scss');

export default observer(function PublishPbpFull() {
    const onPublishedStatusChanged = (ev?: React.MouseEvent<HTMLElement>, checked?: boolean) => {
        setPublishedStatus(checked);
    };

    return (
        <div>
            <OptionDescription>{strings.options_pbp_publishPbpDescription}</OptionDescription>
            <div className={styles.publishToggleSection}>
                <Toggle
                    onText={strings.options_pbp_publishPbpToggleOnLabel}
                    offText={strings.options_pbp_publishPbpToggleOffLabel}
                    checked={getPublishedStatus()}
                    disabled={isSaving()}
                    onChange={onPublishedStatusChanged}
                />
                {isSaving() && <Spinner size={SpinnerSize.small} className={styles.spinner} />}
            </div>
        </div>
    );
});
